import { z } from 'zod'
import { passwordSchema } from './user.input.js'
import { timezoneSchema } from '../validators/timezone.validator.js'
import { emailSchema } from '../validators/email.validator.js'

/**
 * Accepting the terms of service and the privacy policy, at the versions the
 * person was shown. The API refuses versions that are not the ones in force, so
 * nobody is recorded as agreeing to text they never saw.
 */
export const legalAcceptanceInputSchema = z
  .object({
    termsVersion: z.string().min(1).max(64),
    privacyVersion: z.string().min(1).max(64),
  })
  .strict()

export type LegalAcceptanceInput = z.infer<typeof legalAcceptanceInputSchema>

/** A company's first venue — enough to schedule with from the start. */
export const firstVenueInputSchema = z
  .object({
    name: z.string().trim().min(1, 'Name the venue').max(200),
    address: z.string().trim().min(1, 'Give the venue’s address').max(300),
    timezone: timezoneSchema,
  })
  .strict()

export type FirstVenueInput = z.infer<typeof firstVenueInputSchema>

/**
 * Self-serve signup: the company, the person who will run and pay for it, and
 * its first venue, in one step. The trial starts when Checkout completes.
 */
export const signupInputSchema = z
  .object({
    companyName: z.string().trim().min(1, 'Name the company').max(160),
    name: z.string().trim().min(1, 'Give your name').max(160),
    email: emailSchema.max(254),
    password: passwordSchema,
    venue: firstVenueInputSchema,
    legal: legalAcceptanceInputSchema,
  })
  .strict()

export type SignupInput = z.infer<typeof signupInputSchema>
